import React from 'react';
import PropTypes from 'prop-types';

const Body = ({ item, actionKey, title, selectedCount }) => {
  switch (title) {
  case 'Change status':
    const statuses = {
      1: 'Pending',
      2: 'Answered',
      3: 'Closed',
    };
    return (
      <div className="text-center">
        Are you sure you want to change the status of
        {' '}
        <b>{selectedCount}</b>
        {' '}
        selected tickets to
        {' '}
        <b style={{ whiteSpace: 'nowrap' }}>{statuses?.[actionKey]}</b>
        ?
      </div>
    );

  case 'Mark as unread':
    return (
      <div className="text-center">
        Are you sure you want to mark
        {' '}
        <b>{selectedCount}</b>
        {' '}
        selected tickets as unread?
      </div>
    );

  case 'Close and lock':
    return (
      <div className="text-center">
        Are you sure you want to close and lock
        {' '}
        <b>{selectedCount}</b>
        {' '}
        selected tickets?
      </div>
    );

  case 'Delete':
    return (
      <div className="text-center">
        Are you sure you want to delete
        {' '}
        <b>{selectedCount}</b>
        {' '}
        selected tickets?
      </div>
    );

  case 'Assign':
    return (
      <div className="text-center">
        Are you sure you want to assign
        {' '}
        <b>{selectedCount}</b>
        {' '}
        selected tickets to
        {' '}
        <b>{item.name}</b>
        ?
      </div>
    );

  default:
    return '';
  }
};

Body.propTypes = {
  item: PropTypes.object,
  title: PropTypes.string,
  selectedCount: PropTypes.number,
  actionKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Body;
